module.exports = __webpack_public_path__ + "assets/img/2.72b9b812.png";